













































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Gender, RiskLevelForScore, TEST_DATA } from "@/model/Model";
import { Borough } from "@/model/Boroughs";
import { RiskLevel } from "@/model/RiskLevel";

@Component
export default class DrinkingComparison extends Vue {
  public static navButtonLabel: () => string = () =>
    "How does my drinking compare?";
  public static get navButtonClasses(): string[] {
    return [
      "drinking-comparison",
      TEST_DATA.state.gender() === Gender.Male ? "male" : "female"
    ];
  }

  @Prop() public score!: number;
  @Prop() public units!: number;
  @Prop() public calories!: number;
  @Prop() public gender!: Gender;
  @Prop() public commissioned!: boolean;
  @Prop() public region!: Borough;
  @Prop() public isMobile!: boolean;

  private showContent: boolean = false;

  private toggleContent() {
    this.showContent = !this.showContent;
  }

  private get isMale(): boolean {
    return this.gender === Gender.Male;
  }

  private get isFemale(): boolean {
    return this.gender === Gender.Female;
  }

  private get isLowerRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Lower;
  }

  private get isIncreasingRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Increasing;
  }

  private get isHigherRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Higher;
  }

  private get isHighRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.High;
  }

  private get percentageMajority(): number {
    switch (this.gender) {
      case Gender.Male:
        return 72;
      case Gender.Female:
        return 85;
    }
  }

  private get percentageTargetDemo(): number {
    const riskLevel = RiskLevelForScore(this.score);
    switch (this.gender) {
      case Gender.Male:
        switch (riskLevel) {
          case RiskLevel.Lower:
            return 72;
          case RiskLevel.Increasing:
            return 23;
          case RiskLevel.Higher:
            return 3;
          case RiskLevel.High:
            return 2;
          default:
            return 0;
        }
      case Gender.Female:
        switch (riskLevel) {
          case RiskLevel.Lower:
            return 85;
          case RiskLevel.Increasing:
            return 13;
          case RiskLevel.Higher:
            return 1;
          case RiskLevel.High:
            return 1;
          default:
            return 0;
        }
    }
  }

  private get genderPronoun(): string {
    switch (this.gender) {
      case Gender.Male:
        return "men";
      case Gender.Female:
        return "women";
    }
  }
}
